import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=69e6a8a0&scoped=true&"
import script from "./copy.vue?vue&type=script&lang=ts&"
export * from "./copy.vue?vue&type=script&lang=ts&"
import style0 from "./copy.vue?vue&type=style&index=0&id=69e6a8a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e6a8a0",
  null
  
)

export default component.exports